A suggested question component.
